/* eslint-disable react/no-did-update-set-state */
/* eslint-disable react/destructuring-assignment */
import React, { Component } from 'react'
import { withTranslation } from 'react-i18next';
import { compose } from 'redux';
import classNames from 'classnames';
import some from 'lodash/some'

import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { InputTextarea } from 'primereact/inputtextarea';

import FileInput from '@components/FileInput';



class DomainModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loadingPage: true,
      domain: '',
      documentFile: [],
      errors: [],
      btnLoading: false,
      justification: ''
    }
  }

  componentDidMount() {
    this.setState({
      domain: this.props.value || '',
      loadingPage: false
    })
  }

  onSubmit = async (e) => {
    e.preventDefault();
    const { onContinueAction } = this.props
    const { documentFile, justification } = this.state
    this.setState({btnLoading: true})
    const validate = await this.validateFieldsReject()
    if (some(validate, {})) return this.setState({btnLoading: false})
    await onContinueAction({documentFile, justification})
    this.setState({btnLoading: false})
  }

  validateFieldsOnchange = (name, value) => {
    const { errors } = this.state
    if (errors[name] && value) {
      delete errors[name]
      this.setState({errors})
    }
  }

  validateFieldsReject = async () => {
    const { t } = this.props
    const { documentFile, justification } = this.state
    let errors = {}
    if (!documentFile.length) errors = { ...errors, 'documentFile': `${t('Archivo')} ${t('es requerido')}`}
    if (!justification) errors = { ...errors, 'justification': `${t('Justificación del cambio')} ${t('es requerido')}`}

    this.setState({errors})
    return errors
  }

  uploadFile = (files, isImage) => {
    const { nameDocument } = this.props
    const [file] = files;
    const { name: fileName } = file;
    const localUrl = URL.createObjectURL(file);
    const fileExtension = fileName.split('.').pop();
    const data = {
      fileName: nameDocument,
      currentValue: localUrl,
      file,
      fileExtension,
      isImage,
    };
    this.setState({ documentFile: [data] }, () => this.validateFieldsOnchange('documentFile', data));
  };

  removeFile = () => {
    this.setState({ documentFile: [] });
  };

  isFormFieldValid = (name) =>
    !!(this.state.errors[name]);

  getFormErrorMessage = (name) =>
    this.isFormFieldValid(name) && (
      <small className="p-error">{this.state.errors[name]}</small>
    );
  
  render () {
    const { t, onHidden, nameDocument } = this.props
    const { loadingPage,documentFile, btnLoading } = this.state

    const children = loadingPage ? '' : (
      <form className="p-mt-2 p-fluid" onSubmit={this.onSubmit}>
        <div className="p-col">
          <label className="">{t('Ustede va actualizar el siguiente archivo {{FILENAME}}', {FILENAME: nameDocument})}</label>
        </div>
        <div className="p-col">
          <label className="">{t('Archivo')}</label>
        </div>
        <div className="p-col-12">
          <FileInput
            onChangeFile={this.uploadFile}
            files={documentFile}
            removeAllFiles={this.removeFile}
            removeFile={this.removeFile}
            accept=".doc, .docx"
            txtDrop={t('Arrastra y suelta el archivo')}
            classNameBorderMain={classNames({
              'p-invalid': this.isFormFieldValid('documentFile'),
            })}
          />
          {this.getFormErrorMessage(`documentFile`)}
        </div>
        <div className='p-col-12'>
          <label className="">{t('Justificación del cambio')}</label>
          <InputTextarea
            name="justification"
            onChange={(e) =>
              this.setState({ justification: e.target.value }, this.validateFieldsOnchange('justification', e.target.value))
            }
            rows={5}
            cols={30}
            className={classNames({
              'p-invalid': this.isFormFieldValid(`justification`),
            })}
          />
          {this.getFormErrorMessage(`justification`)}
        </div>
        <div className="p-dialog-footer custom">
          <div>
            <button className="p-button p-component p-button-raised p-button-secondary p-button-text" type="button" onClick={() => onHidden()}>
              <span className="p-button-label p-c">{t('Cerrar')}</span>
            </button> 
            <Button
              type="submit"
              label={t('Actualizar')}
              loading={btnLoading}
            />
          </div>
        </div>
      </form>
    )
    if (loadingPage) return true;

    return (
      <Dialog
        header={t('Actualizar Anexo')}
        visible
        breakpoints={{'960px': '90vw'}}
        style={{ width: '40vw' }}
        onHide={onHidden}
      >
        {children}
      </Dialog>
    )
  }
}



export default compose(
  withTranslation()(DomainModal))